import { Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CookieUtilsService } from '../../../shared/utils/cookie-utils.service';
import { routeMap } from 'src/app/app.settings';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  readonly languages: string[] = ['fr', 'nl'];
  public language: string;

  readonly defaultLanguage = 'fr';
  readonly languageCookieName = 'lang';

  constructor(
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private cookieService: CookieUtilsService
  ) {}

  public init() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const url = window.location.pathname;
      const match = routeMap.find((el) => el.regex.test(url));

      if (!this.language) {
        this.language = event.lang;
      }

      if (this.location.path() !== '/' && this.language !== event.lang) {
        const newUrl = match
          ? url.replace(`${match.basePath[this.language]}`, `${match.basePath[event.lang]}`) + window.location.search
          : url.replace(this.language, event.lang) + window.location.search;
        this.language = event.lang;
        window.history.replaceState({}, '', newUrl);
      }
    });

    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang(this.defaultLanguage);
    this.language = this.getLanguage();
    this.translate.use(this.language);
    return this.language;
  }

  public getLanguage(): string {
    // Check url language
    const urlLang = this.getUrlLanguage();
    if (urlLang) {
      return urlLang;
    }

    // check browserLanguage
    const browserLang = this.getBrowserLanguage();
    if (browserLang) {
      return browserLang;
    }

    // Return default
    return this.defaultLanguage;
  }

  public getUrlLanguage(): string {
    const urlLang = window.location.pathname.split('/')[1];
    if (this.languages.find((el) => el === urlLang)) {
      return urlLang;
    }

    return;
  }

  private getBrowserLanguage() {
    const browserLang = this.translate.getBrowserLang();
    if (this.languages.find((el) => el === browserLang)) {
      return browserLang;
    }
  }
}
